import React from 'react';
import { Mail } from 'lucide-react';
import { useTranslations } from '@/lib/translations';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_wonderchat-mobile/artifacts/9pn3gi8c_ChatGPT%20Image%207%20feb%202026%2C%2019_58_01.png";

export const Footer = () => {
    const t = useTranslations();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-card border-t border-border">
            <div className="container mx-auto px-4 py-8">
                {/* Main Footer Content */}
                <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="flex items-center gap-3">
                        <img 
                            src={LOGO_URL} 
                            alt="Logo" 
                            className="h-12 w-12 object-contain"
                        />
                    </div>

                    {/* Email Contact */}
                    <a 
                        href="mailto:info@mygymbro.es"
                        className="flex items-center gap-2 text-foreground/70 hover:text-primary transition-colors duration-300"
                    >
                        <Mail className="w-4 h-4" />
                        <span className="text-sm">info@mygymbro.es</span>
                    </a>
                </div>

                {/* Disclaimer */}
                <p className="text-xs text-foreground/50 text-center mt-6 max-w-2xl mx-auto leading-relaxed">
                    GymBro es una aplicación privada de acceso exclusivo para miembros de BUNKER. Propiedad de Global de Innovaciones S.L. Prohibido el acceso no autorizado, copia, reproducción o distribución total o parcial.
                </p>

                {/* Divider */}
                <div className="border-t border-border/50 my-6" />

                {/* Bottom Bar */}
                <div className="flex flex-col sm:flex-row justify-between items-center gap-3 text-sm text-foreground/70">
                    <p>&copy; {currentYear} Global de Innovaciones SL. Todos los derechos reservados.</p>
                    <div className="flex gap-6">
                        <a 
                            href="https://gdi.live/privacy-policy/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="hover:text-primary transition-colors"
                        >
                            {t.privacyPolicy}
                        </a>
                        <a 
                            href="https://gdi.live/privacy-policy/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="hover:text-primary transition-colors"
                        >
                            {t.termsOfService}
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
